import { defineComponent as _defineComponent } from 'vue'
import Vue, { ref } from 'vue';
import VueObserveVisibility from 'vue-observe-visibility';

import BasicButton from '@/ui-components/BasicButton.vue';

import { useI18n } from '@/helpers/composables/useI18n';
import { useConstantStore, useFilterStore, useUserStore } from '@/helpers/composables/useStores';

import { CollectionType } from '@/enums/collection-type';
import { OnboardingStatus } from '@/enums/onboarding-status';

import { TrackingHelper } from '@/helpers/tracking/tracking-helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'CallToAction',
  emits: ['click'],
  setup(__props, { emit }) {

Vue.use(VueObserveVisibility);



const { tc } = useI18n();
const { preselectedProviders } = useConstantStore();
const { setFilterValue } = useFilterStore();
const { saveOnboardingStatus, saveSettings, isLoggedIn } = useUserStore();

const ctaShownOnce = ref(false);
function visibilityChanged(isVisible: boolean) {
	if (!ctaShownOnce.value && isVisible) {
		ctaShownOnce.value = true;

		TrackingHelper.trackEvent(
			'discovery',
			{
				property: 'app.home.global.BOTTOM',
				label: tc('WEBAPP_GLOBAL_CTA'),
				action: 'invitation_seen',
				nonInteraction: true,
			},
			[TrackingHelper.getPageTypeContext()]
		);
	}
}

const collectionTypes = [CollectionType.POPULAR, CollectionType.NEW];

async function discoverClickHandler() {
	collectionTypes.forEach(collectionType => {
		setFilterValue({
			filterName: 'providers',
			filterValue: [],
			collectionType,
			updateRouteState: false,
		});
	});

	TrackingHelper.trackEvent('discovery', {
		action: 'invitation_clicked',
		property: 'bottom',
	});

	await saveSettings({ providers: preselectedProviders.value });

	saveOnboardingStatus(isLoggedIn.value ? OnboardingStatus.SIGNED_UP : OnboardingStatus.GLOBAL_CLICKED_CTA);

	emit('click');
}

return { __sfc: true,emit, tc, preselectedProviders, setFilterValue, saveOnboardingStatus, saveSettings, isLoggedIn, ctaShownOnce, visibilityChanged, collectionTypes, discoverClickHandler, BasicButton }
}

})